import { render, staticRenderFns } from "./alert_datatable.vue?vue&type=template&id=345274ec&"
import script from "./alert_datatable.vue?vue&type=script&lang=js&"
export * from "./alert_datatable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports